// app lib
import isProduction from '../../app/lib/isProduction.lib.app';

// Session Replay: If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
const REPLAYS_ON_ERROR_SAMPLE_RATE = () => (isProduction() ? 0.1 : 1.0);

export default REPLAYS_ON_ERROR_SAMPLE_RATE;
